/* @ngdoc object
 * @name components
 * @description
 *
 */
angular
    .module('festzelt-os.components')
    .config([
        'Env',
        'RestangularProvider',
        restangular
    ]);

function restangular(Env, RestangularProvider) {
    RestangularProvider
        .setBaseUrl(Env.apiUrl)
        .setRestangularFields({
            selfLink: 'self.link'
        })
        .setDefaultHeaders({'Content-Type': 'application/json'})
        .setParentless(['guestlists']);
}



// WEBPACK FOOTER //
// ./src/app/components/components-restangular.js